exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notesSetter {\n  list-style: none;\n  padding: 0;\n  margin: 5px 0;\n  display: flex;\n}\n", ""]);

// exports
